<template>
  <div class="container-from-to">
    <div class="row row-title">
      <div class="col color-blue text-center">
        <h1 class="mb-5">4. ELIJE A QUIÉN SE LO ENVIARÁS</h1>
        <h3>Incluye tu nombre y el nombre de tu persona especial</h3>
      </div>
    </div>
    <div class="row">
      <div class="col color-blue font-general-r">

        <div class="container-form">
          <img class="caritafeliz" src="@/assets/store/diloconnieve/caritafeliz.svg" alt="">

          <div>
            <div class="mb-5 text-center">
              <label class="h5 font-weight-bold" for="from">DE:</label>
              <input v-model="from_to.from" name="from" v-validate="'required'" data-vv-as="De" class="input-nv" id="from">
              <br>
              <span v-show="errors.has('from')" class="text-danger mt-2">
                {{ errors.first("from") }}
              </span>
            </div>

            <div class="text-center">
              <label class="h5 font-weight-bold" for="to">PARA:</label>
              <input v-model="from_to.to" name="to" v-validate="'required'" data-vv-as="Para" class="input-nv" id="to">
              <br>
              <span v-show="errors.has('to')" class="text-danger mt-2">
                {{ errors.first("to") }}
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['from_to']
}
</script>

<style scoped>
.container-from-to {
  background-color: var(--color-light);
  width: 100%;
  font-family: var(--font-baloo-regular);
  padding: 25px;
}
.container-from-to .row-title {
  margin-bottom: 2%;
  margin-top: 2%;
}
.container-form {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.caritafeliz {
  margin-right: 5%;
  width: 10%;
}
@media only screen and (min-width: 960px) and (max-width: 1264px) {
  .container-from-to h1 {
    font-size: 30px !important;
  }
  .container-from-to h3 {
    font-size: 22px !important;
  }
}
@media (max-width: 768px) {
  .container-from-to h1 {
    font-size: 30px !important;
  }
  .container-from-to h3 {
    font-size: 22px !important;
  }
  .caritafeliz {
    width: 15%;
  }
}
@media only screen and (min-width: 360px) and (max-width: 490px) {
  .container-from-to h1 {
    font-size: 22px !important;
  }
  .container-from-to h3 {
    font-size: 17px !important;
  }
  .caritafeliz {
    margin-right: 0;
    width: 25%;
    margin-bottom: 30px;
  }
}
</style>

